// ConfidenceBar — 0–100 with tooltip explaining the computation
interface ConfidenceBarProps {
  value: number;
  showLabel?: boolean;
}

export function ConfidenceBar({ value, showLabel = true }: ConfidenceBarProps) {
  const level = value >= 70 ? 'high' : value >= 40 ? 'medium' : 'low';

  return (
    <span className="confidence-bar" title={`Confidence: ${value}/100 — computed from source count, assertion density, and trust weights`}>
      <span className="bar">
        <span className={`bar-fill ${level}`} style={{ width: `${value}%` }} />
      </span>
      {showLabel && <span className="text-mono text-sm">{value}</span>}
    </span>
  );
}
